import { render, staticRenderFns } from "./storeRequisition.vue?vue&type=template&id=5b4fa9ea"
import script from "./storeRequisition.ts?vue&type=script&lang=js&external"
export * from "./storeRequisition.ts?vue&type=script&lang=js&external"
import style0 from "./storeRequisition.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports